import gql from 'graphql-tag';

export const removeOrderMutation = gql`
  mutation removeOrder {
    removeOrder {
      Status
    }
  }
`;
